import React from 'react';

import {
  Group,
  Spacing,
} from '@vkontakte/vkui';

import { FriendLinkForm } from './components/FriendLinkForm';
import { Payment } from './components/Payment';
import styles from './DesktopUserEnteringPage.module.css';
import { DesktopUserEnteringPageProps } from './types';
import { HeaderImage } from '../../../panels/components/HeaderImage';

export const DesktopUserEnteringPage: React.FC<DesktopUserEnteringPageProps> = ({
  handlePayButtonClick,
  handleUserSearchButton,
  onTextInputChange,
  textInput,
  error
}) => {
  return (
    <div>
      <Group className={styles.container} separator="hide">
        <HeaderImage/>
        <Spacing size={40} />
        <FriendLinkForm
          textInput={textInput}
          onTextInputChange={onTextInputChange}
          handleUserSearchButton={handleUserSearchButton}
          error={error}
        />
        <Spacing size={32} />
        <Payment handlePayButtonClick={handlePayButtonClick}/>
      </Group>
    </div>
  );
};
